import React, { useState, useEffect } from 'react';
import config from '../../config/apiConfig';
import { hoyChile, primerDiaMesChile } from '../../services/utils';

const ReporteVariantes = () => {
    const hoy = hoyChile();
    const primerDiaMes = primerDiaMesChile();

    const [filtros, setFiltros] = useState({ inicio: primerDiaMes, fin: hoy });
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [pestanaActiva, setPestanaActiva] = useState('toppings'); // 'toppings' o 'combinaciones'

    const formCant = (cant) => {
        const num = Number(cant);
        return num % 1 === 0 ? num : num.toFixed(1);
    };

    const cargarReporte = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            const url = `${config.api_url}/api/reportes/variantes-vendidas?inicio=${filtros.inicio}&fin=${filtros.fin}`;
            const res = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'token': token
                }
            });

            const json = await res.json();
            if (json.status === 'success') {
                setData(json);
            } else {
                console.error("Error en respuesta:", json);
            }
        } catch (e) {
            console.error("Error al cargar reporte de variantes:", e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        cargarReporte();
    }, []);

    const rankingActual = pestanaActiva === 'toppings'
        ? (data && data.ranking_toppings ? data.ranking_toppings : [])
        : (data && data.ranking_producto_topping ? data.ranking_producto_topping : []);

    const totalMaximo = rankingActual.length > 0 ? Number(rankingActual[0].cantidad) : 1;

    return (
        <div className="card shadow-sm border-0 rounded-lg p-4">
            <h4 className="font-weight-bold mb-4">
                <i className="fas fa-pizza-slice text-warning mr-2"></i> Toppings / Variantes Vendidas
            </h4>

            {/* Selector de fechas */}
            <div className="row mb-4">
                <div className="col-md-5">
                    <input
                        type="date"
                        className="form-control"
                        value={filtros.inicio}
                        onChange={e => setFiltros({ ...filtros, inicio: e.target.value })}
                    />
                </div>
                <div className="col-md-5">
                    <input
                        type="date"
                        className="form-control"
                        value={filtros.fin}
                        onChange={e => setFiltros({ ...filtros, fin: e.target.value })}
                    />
                </div>
                <div className="col-md-2">
                    <button className="btn btn-dark btn-block" onClick={cargarReporte}>
                        <i className="fas fa-search mr-1"></i> OK
                    </button>
                </div>
            </div>

            {/* Pestañas */}
            <ul className="nav nav-tabs mb-4">
                <li className="nav-item">
                    <button
                        className={`nav-link ${pestanaActiva === 'toppings' ? 'active font-weight-bold' : ''}`}
                        onClick={() => setPestanaActiva('toppings')}
                    >
                        <i className="fas fa-list mr-1"></i> Ranking de Toppings
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${pestanaActiva === 'combinaciones' ? 'active font-weight-bold' : ''}`}
                        onClick={() => setPestanaActiva('combinaciones')}
                    >
                        <i className="fas fa-link mr-1"></i> Por Producto + Topping
                    </button>
                </li>
            </ul>

            {/* Info de totales */}
            {data && (
                <div className="alert alert-info py-2 mb-3">
                    <i className="fas fa-chart-bar mr-2"></i>
                    <strong>{data.total_pedidos}</strong> pedidos analizados | Período: <strong>{data.fecha}</strong>
                </div>
            )}

            {/* Contenido */}
            {loading ? (
                <div className="text-center py-5">
                    <i className="fas fa-spinner fa-spin fa-2x text-primary"></i>
                    <p className="mt-2 text-muted">Analizando variantes...</p>
                </div>
            ) : rankingActual.length === 0 ? (
                <div className="text-center py-5 text-muted">
                    <i className="fas fa-inbox fa-3x mb-3"></i>
                    <p>No hay datos de variantes en este rango.</p>
                </div>
            ) : (
                <div>
                    {pestanaActiva === 'toppings' ? (
                        /* Ranking de Toppings */
                        rankingActual.map((item, i) => (
                            <div key={i} className="mb-3">
                                <div className="d-flex justify-content-between mb-1">
                                    <span className="font-weight-bold">
                                        {i < 3 ? ['🥇', '🥈', '🥉'][i] : `${i + 1}.`} {item.topping}
                                    </span>
                                    <span className="badge badge-primary badge-pill">
                                        {formCant(item.cantidad)} unid.
                                    </span>
                                </div>
                                <div className="progress" style={{ height: '10px', borderRadius: '5px' }}>
                                    <div
                                        className={`progress-bar ${i < 3 ? 'bg-warning' : 'bg-info'}`}
                                        style={{ width: `${(Number(item.cantidad) / totalMaximo) * 100}%` }}
                                        title={`${formCant(item.cantidad)} unidades`}
                                    ></div>
                                </div>
                            </div>
                        ))
                    ) : (
                        /* Ranking Producto + Topping */
                        <div className="table-responsive">
                            <table className="table table-hover table-sm">
                                <thead className="thead-dark">
                                    <tr>
                                        <th>#</th>
                                        <th>Combinación</th>
                                        <th className="text-center">Cantidad</th>
                                        <th style={{ width: '40%' }}>Proporción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rankingActual.map((item, i) => {
                                        const partes = item.combinacion.split(' → ');
                                        return (
                                            <tr key={i}>
                                                <td className="font-weight-bold text-muted">{i + 1}</td>
                                                <td>
                                                    <span className="badge badge-secondary mr-1">{partes[0]}</span>
                                                    <i className="fas fa-arrow-right mx-1 text-muted small"></i>
                                                    <span className="font-weight-bold">{partes[1]}</span>
                                                </td>
                                                <td className="text-center">
                                                    <span className="badge badge-primary badge-pill">
                                                        {formCant(item.cantidad)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="progress" style={{ height: '8px', borderRadius: '4px' }}>
                                                        <div
                                                            className="progress-bar bg-success"
                                                            style={{ width: `${(Number(item.cantidad) / totalMaximo) * 100}%` }}
                                                        ></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ReporteVariantes;
